import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>
        This page is not available right now, or it may have been moved.
      </p>
      <Link to="/">Back to Home</Link>
    </div>
  );
};

export default NotFoundPage;
